import { breakpoints, colors, font, spacing } from '@chegg-ui/theme'
import styled from 'styled-components'

export const AIPoweredBadgeContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: ${spacing.px4};
  align-items: center;
  align-self: flex-start;
  border-radius: ${spacing.px4};

  padding: ${spacing.px4} ${spacing.px8};
  background-color: ${colors.violet100};
  color: ${colors.violet700};
  font-size: ${font.size.px12};

  @media only screen and (min-width: ${breakpoints.md.min}) {
    align-self: center;
  }
`

export const BadgeHeading = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${spacing.px8};

  @media only screen and (min-width: ${breakpoints.md.min}) {
    flex-direction: row;
    column-gap: ${spacing.px12};
    row-gap: 0;
  }
`

export const CardImageCarouselContainer = styled.section`
  background-color: ${colors.white};
  padding: 0;
  border-radius: ${spacing.px24};
  margin-bottom: 0;

  @media only screen and (min-width: ${breakpoints.md.max}) {
    background-color: ${colors.violet050};
    padding: ${spacing.px24};
  }
`

export const CarouselCardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${spacing.px24};
  overflow-x: auto;
  background-color: ${colors.violet050};
  border-radius: ${spacing.px24};

  @media only screen and (min-width: ${breakpoints.md.min}) {
    row-gap: ${spacing.px24};
    flex-direction: row;
    column-gap: ${spacing.px24};
    row-gap: 0;
    font-size: ${font.size.px52};
  }

  @media only screen and (min-width: ${breakpoints.md.min}) {
    background-color: ${colors.white};
  }

  @media only screen and (min-width: ${breakpoints.lg.min}) {
    background-color: ${colors.violet050};
  }
`
